import { render, staticRenderFns } from "./BookingPrivateDocuments.vue?vue&type=template&id=e3898922&scoped=true&"
import script from "./BookingPrivateDocuments.vue?vue&type=script&lang=ts&"
export * from "./BookingPrivateDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./BookingPrivateDocuments.vue?vue&type=style&index=0&id=e3898922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3898922",
  null
  
)

export default component.exports